import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Menu,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';

import { fetchM } from '../../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../../actions/flash';
import MediaList from '../../../../components/MediaList';
import NavBar from '../../../../components/NavBar';
import AddMedia from '../../../modals/AddMedia';
import ViewLarge from '../../../modals/ViewLarge';
import RemoveMedia from '../../../modals/RemoveMedia';
import LayoutTitle from '../LayoutTitle';
import { routes } from '../navigations';
import { namespaces, TRANSLATION_FILES } from '../../../../constants/translation';

class Videos extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    mediaToken: PropTypes.string,
    id: PropTypes.string,
    unitLayoutID: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Videos.getPropsToState(props);
    this.state = {
      ...state,
      showConfirm: false,
      showLarge: false,
      selectedMedia: null,
      showAddMedia: false,
      pictures: [],
    };
    this.mediaList = null;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Videos.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleRefetch() {
    this.mediaList.getWrappedInstance().handleRefetch();
  }
  addMedia = () => {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/medias/${this.state.selectedMedia.id}/`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
    }))
      .then(() => {
        this.mediaModal.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Add Video Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully added to unit layout', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  deleteMedia() {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/medias/${this.state.selectedMedia.id}/`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
    }))
      .then(() => {
        this.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Delete Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully deleted', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleCancelRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
      selectedMedia: null,
    });
  }
  handleRemove = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
    }, () => {
      this.setState({
        showConfirm: true,
      });
    });
  }
  handleConfirmRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
    }, () => {
      this.deleteMedia();
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedMedia: null,
    });
  }
  handleViewLarge = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
      showLarge: true,
    });
  }
  handleShowAddMedia = (e) => {
    e.preventDefault();
    this.setState({
      showAddMedia: true,
    });
  }
  handleCloseAddMedia = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleRefetch();
    this.setState({
      showAddMedia: false,
    });
  }
  handleAddMedia = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
    }, () => {
      this.addMedia();
    });
  }
  handleCreate = data => ({
    url: `/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/medias/`,
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
      body: JSON.stringify(data),
    },
  })
  handleCheck = (data) => {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(p => p.projectUnitLayoutID === this.props.unitLayoutID);
    }
    return false;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleGetVideos = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedMedia } = this.state;
    const index = pictures.indexOf(selectedMedia);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedMedia: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedMedia } = this.state;
    if (selectedMedia) {
      const index = pictures.indexOf(selectedMedia);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    const { pathname } = this.props.location;
    const { store } = this.context;
    const links = routes(this.props.id, this.props.unitLayoutID, true);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={() => store.dispatch(replace(link.value))}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleShowAddMedia}
                disabled={this.state.loading}
                primary
                icon="add"
                content={t('Add', { ns: TRANSLATION_FILES.translation })}
              />
            </Menu.Item>
          }
        />
        <LayoutTitle data={this.props.data} />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <AddMedia
                type="unit_layout"
                ref={(ref) => { this.mediaModal = ref; }}
                open={this.state.showAddMedia}
                onClose={this.handleCloseAddMedia}
                onConfirm={this.handleAddMedia}
                onCreate={this.handleCreate}
                onCheck={this.handleCheck}
              />
              <ViewLarge
                open={this.state.showLarge}
                onClose={this.handleCloseLarge}
                picture={this.state.selectedMedia}
                type="video"
              />
              <RemoveMedia
                open={this.state.showConfirm}
                onClose={this.handleCancelRemove}
                onConfirm={this.handleConfirmRemove}
                media={this.state.selectedMedia}
                data={this.props.data}
              />
              <MediaList
                ref={(ref) => { this.mediaList = ref; }}
                toggleable
                projectID={this.props.id}
                unitLayoutID={this.props.unitLayoutID}
                onChange={this.handleGetVideos}
                onViewLarge={this.handleViewLarge}
                onRemove={this.handleRemove}
                buttonNode={({ isMobile, view, loading, item }) => (
                  view === 'list' ? (
                    <Button
                      size="tiny"
                      compact
                      negative
                      icon="remove"
                      content={isMobile ? null : 'Remove'}
                      disabled={loading}
                      onClick={e => this.handleRemove(e, item)}
                    />
                  ) : null
                )}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(...namespaces)(Videos);



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/Videos/List.jsx